//All imports happen at the top of the file
import { Box } from "@mui/material";
import GoogleDriveQuickstart from "./components/GoogleDriveQuickstart";
import TrackRequisitionsTable from "./components/TrackRequisitionsTable";

const GOOGLE_DRIVE_INTEGRATION_ENABLED =
	process.env.REACT_APP_ENABLE_GOOGLE_DRIVE_INTEGRATION === "true";

export default function TrackRequisitions() {
	return (
		<div className="flex flex-col items-center justify-start w-full h-[100vh] bg-digitalWhite">
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					width: { xs: "100%", sm: "100%", md: "100%", lg: "95%" },
					justifyContent: "center",
					borderBottom: "none",
					mt: "2rem",
					borderRadius: "5px 5px 0px 0px",
					height: "90vh",
				}}
				className=""
			>
				{GOOGLE_DRIVE_INTEGRATION_ENABLED ? (
					<div className="overflow-y-scroll max-h-[20dvh]">
						<GoogleDriveQuickstart />
					</div>
				) : null}
				<TrackRequisitionsTable />
			</Box>
		</div>
	);
}
